<template>
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="Tirelire"
  >
    <g id="Orion_money-box 2">
      <path
        id="layer1"
        d="M14.4 9.75C13.1609 9.90371 11.9589 10.2762 10.85 10.85C6.9 12.95 6.25 16.35 6.25 19C6.25 21.65 7.4 25.55 11.65 29H15.3V27L19.75 27.25C20.0713 27.8718 20.4568 28.4583 20.9 29H24.25V26C25.3164 25.2497 26.3197 24.4136 27.25 23.5C28.7 23.65 30.2 22.5 30.75 19.15C30.75 18.65 30.5 18.5 30.25 18.5C29.7177 18.4535 29.2038 18.2822 28.75 18C28.55 17.75 27.95 15.65 26.85 14C27.2687 12.954 27.9805 12.0512 28.9 11.4C27.5 10.7 26.05 10.2 23.2 10.5C22.45 10.35 21.2 10.05 20 9.85"
        stroke="currentColor"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />

      <path
        id="layer2"
        d="M17.25 11C19.4591 11 21.25 9.20914 21.25 7C21.25 4.79086 19.4591 3 17.25 3C15.0409 3 13.25 4.79086 13.25 7C13.25 9.20914 15.0409 11 17.25 11Z"
        stroke="currentColor"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />

      <path
        id="layer1_2"
        d="M6.25 19C4.8 18.85 1.25 18.3 1.25 20C1.25 21.7 2.2 21.7 3.15 21.3C4.1 20.9 5.3 18.55 1.25 17M14.1 12.55C16.1556 11.8475 18.3836 11.83 20.45 12.5"
        stroke="currentColor"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />

      <path
        id="layer1_3"
        d="M24.25 17.5C24.5261 17.5 24.75 17.2761 24.75 17C24.75 16.7239 24.5261 16.5 24.25 16.5C23.9739 16.5 23.75 16.7239 23.75 17C23.75 17.2761 23.9739 17.5 24.25 17.5Z"
        stroke="currentColor"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
  </svg>
</template>
